// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex)

import App from './index.vue'
import router from './router'

import axios from 'axios';
//axios
Vue.prototype.$axios = axios;

import qs from "qs"
Vue.prototype.$qs = qs

//store
import store from "./store";
Vue.prototype.$store = store;

//FREE
import Free_login from '@/assets/js/freeLogin.js';

//kd
//import Kd from '@/assets/js/kd.js';

//global
import GLOBAL from '@/assets/js/global.js';
Vue.prototype.$global = GLOBAL;
Vue.prototype.$ajax_url_map = GLOBAL.ajax_url_map;

//misc
import Misc from '@/assets/js/misc.js';

//login
import mslogin from '@/assets/js/msLogin.js';
Vue.prototype.$mslogin = mslogin;
mslogin.defaults.loginUrl = GLOBAL.ajax_url_map.login;

//wx_share
import wx from '@/assets/js/wxapi.jsonp.js';

//loading
import loading from '@/components/Loading'
Vue.use(loading)

//clipboard
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

// Toast
import Toast from '@/components/Toast';
Vue.prototype.$toast = Toast;

// bind_Modal
import Bind_Modal from '@/components/AreaBind';
Vue.prototype.$bind_modal = Bind_Modal;

// Share_Modal
import Share_Modal from '@/components/ShareModal';
Vue.prototype.$share_modal = Share_Modal;

// Skin_Modal
import Skin_Modal from '@/components/SkinModal';
Vue.prototype.$skin_modal = Skin_Modal;

// Discount_Detail_Modal
import Discount_Detail_Modal from '@/components/DiscountDetail';
Vue.prototype.$discount_detail = Discount_Detail_Modal;

// Sale_Detail_Modal
import Sale_Detail_Modal from '@/components/SaleDetailModal';
Vue.prototype.$sale_detail = Sale_Detail_Modal;

// Buy_Modal
import Buy_Modal from '@/components/BuyModal';
Vue.prototype.$buy_modal = Buy_Modal;

// Order_Modal
import Order_Modal from '@/components/OrderDetail';
Vue.prototype.$order_detail = Order_Modal;

// Offer_Modal
import Offer_Modal from '@/components/OfferModal';
Vue.prototype.$offer_modal = Offer_Modal;

//item_view
import gameItem from '@/components/itemview.vue'
Vue.component('game-item', gameItem)

//itemData
import Item_data from '@/assets/json/itemData.json';
Vue.prototype.$tips_data = Item_data;

//tips_data
window.tips_data = {};

// item_tips
import Item_Tips from '@/components/ItemTips';
Vue.prototype.$item_tips = Item_Tips;

//queryArea
Vue.prototype.$queryArea = function (aid){
    if(!aid)return;
    return this.$global.areaList.filter(function(e){
        return e.id == aid;
    })[0].name;  
}

//goodlist update
Vue.prototype.$goodslist_update = function (list){
    mainApp.goodslist = list;
}

Vue.prototype.$get_goodslist = function (){
    return mainApp.goodslist;
}

Vue.prototype.$basket_reflash = function(){
    //mainApp.$refs.basket.render();
}

Vue.prototype.$m3b_reflash = function(val){
    //console.log(mainApp.$refs.mainApp);
    //console.log(mainApp.$refs.mainApp.$refs.view.basket);
    //mainApp.$refs.basket.m3b -= val;
}

Vue.prototype.$goodslist_reflash = function (){
    mainApp.get_goods_list();
}

Vue.prototype.$get_ticket_info = function (){
    mainApp.get_ticket_info();
}

Vue.prototype.$back_index = function (){
    router.push({ name: 'bazaar', });  
}

Vue.prototype.$to_help = function (key){
    router.push({ name: 'help', params: { key: key }});  
}

/* eslint-disable no-new */
var mainApp = new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App ref="mainApp" :ready="ready" :shop_offer="shop_offer"/>',
    data (){
      return {
        account_type : 'pc',
        isLoading : false,
        ready : false,//通信阀门
        ajax_loading : false,  
        shop_offer : [],
        goodslist : [],
        key : '',
        token : '',      
      }
    },
    created (){

        Misc.extra();

        var _this = this;

        if(GLOBAL.getQueryVariable('jwt')){
            this.$store.commit("$_setStorage", GLOBAL.getQueryVariable('jwt'));
            window.history.pushState({}, 0, GLOBAL.domain);
        }

        if(GLOBAL.getQueryVariable('key')){         
            this.$store.commit("$_setCode", GLOBAL.getQueryVariable('key'));
            localStorage.setItem('code', GLOBAL.getQueryVariable('key'));
            window.history.pushState({}, 0, GLOBAL.domain);
        }        
        
        let token = store.state.token;
        let code = store.state.code || localStorage.getItem("code");

        //alert(token)

        this.token = token;

        _this.key = code;

        var instance = axios.create();
        instance.defaults.timeout = 1000 * 20;
        //axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    
        /* 请求拦截 */
        this.$axios.interceptors.request.use(
            config => {

                if (_this.token && config.url != GLOBAL.ajax_url_map.tips) {
                    config.headers["Authorization"] = _this.token;                  
                }
                this.$loading.show();
                  
                return config;
            },
            err => Promise.reject(err)
        );
    
        //请求返回拦截
        this.$axios.interceptors.response.use((response) => {
            this.$loading.hide();
            if (response.data.code === 2) {
                //其余错误状态处理
                return Promise.reject(response.data);
            }
            else if(response.data.code === 401) {
                //未登录
                //localStorage.clear();
                this.token = '';
                // this.$store.commit("$_setLogin", 0);

                localStorage.setItem('token', '');
                localStorage.setItem('account', '');
                localStorage.setItem('userinfo', '');
                store.commit("$_setLogin", 0);
                store.commit("$_setUserinfo", {});
                store.commit("$_setAccount", {}); 
                store.commit("$_setm3b", 0);                 
                
                return Promise.reject(response.data);
            }
            else if(response.data.code === 402) {
                //未绑定大区
                if(response.data.userInfo)this.$store.commit("$_setAccount", response.data.userInfo);
                if(!document.querySelectorAll('.area-modal').length)this.$bind_modal();
                return response.data;
            }            
            else if(response.data.code !== 0){
                return Promise.reject(response.data);
            }
    
            return response.data;
    
        }, function (error) {
            this.$loading.hide();
            return Promise.reject(error);
        }); 
        
        
        this.get_user_info();
        wx.wxInit({
            title: GLOBAL.wx_share_text.title, // 分享标题
            desc: GLOBAL.wx_share_text.desc, // 分享描述
            link: GLOBAL.domain, // 分享链接
            imgUrl: GLOBAL.wx_share_text.imgUrl, // 分享图标            
        });

    },
    mounted (){
        // this.get_user_info();
        // wx.wxInit({
        //     title: GLOBAL.wx_share_text.title, // 分享标题
        //     desc: GLOBAL.wx_share_text.desc, // 分享描述
        //     link: GLOBAL.domain, // 分享链接
        //     imgUrl: GLOBAL.wx_share_text.imgUrl, // 分享图标            
        // });
    },
    methods : {
        get_user_info (){
            let _this = this;

            Free_login.free_login_kd(this.$ajax_url_map.freelogin,function(response){
                if(typeof response !== 'undefined'){
                    _this.token = response;
                }

                _this.user_update();
            })
            
        },
        user_update (){
            var _this = this;
            this.$axios.get(this.$ajax_url_map.userinfo)
            .then(res => {
                this.$store.commit("$_setLogin", 1);
                this.get_goods_list()

                if(res.userInfo)this.$store.commit("$_setAccount", res.userInfo);

                if(res.data){
                    this.$store.commit("$_setUserinfo", res.data);
                    this.$store.commit('$_setTjlSwitch',res.tjlSwitch);
                    this.$store.commit("$_setm3b", res.data.m3b);
                    if(!this.key)this.get_ticket_info();
                }

                //if(res.code == 402)this.$bind_modal();

                if(this.key && this.$store.state.userinfo.areaId){
                    router.push({ name: 'help', params: { key: this.key }});  
                }                         
            },rej=> {
                //this.ready = true;
                this.get_goods_list();
                if(this.key){
                    this.$mslogin.open();
                }
                console.log(rej);
            });
        },
        get_ticket_info (){
            this.$axios.get(this.$ajax_url_map.shop)
            .then(res => {
                //this.ready = true;
                this.shop_offer = res.data.list;

                var offer_apply = this.shop_offer.filter(function(e){
                    return e.state == 1
                })
              
                if(offer_apply.length)this.$offer_modal({
                    shop_list : offer_apply,
                });

            },rej => {
                console.log('店铺优惠券模块：' + res.message);
            })
        },
        get_goods_list(){
            this.$axios.get(this.$ajax_url_map.goodslist)
            .then(res => {
              this.ready = true;
              this.$goodslist_update(res.data.list)
            },
            rej => {
              this.ready = true;
              console.log(rej)
            })            
        },
    }, 
})


// WEBPACK FOOTER //
// ./src/pages/index/index.js